import type { ReactNode } from "react";
import { Navbar } from "./Navbar";
import { Footer } from "./Footer";

export function Layout({ title, children }: { title?: string; children: ReactNode }) {
  return (
    <div className="flex min-h-screen flex-col">
      {/* React 19 hoists <title> to <head> natively — react-helmet is no longer
          needed, and the 2020 app carried it purely for this. */}
      {title && <title>{`${title} | Trade-r`}</title>}
      <Navbar />
      <main className="flex-1">{children}</main>
      <Footer />
    </div>
  );
}

/**
 * Page header.
 *
 * The eyebrow names what kind of thing this is; the title is the thing. Both
 * sit above a heavy rule, which is this design's structural divider.
 */
export function PageHeader({
  eyebrow,
  title,
  subtitle,
  actions,
}: {
  eyebrow?: string;
  title: string;
  subtitle?: string;
  actions?: ReactNode;
}) {
  return (
    <header className="rule">
      <div className="mx-auto flex max-w-5xl flex-wrap items-end justify-between gap-4 px-6 py-10">
        <div>
          {eyebrow && <p className="eyebrow">{eyebrow}</p>}
          <h1 className="mt-1 text-4xl font-black tracking-tighter">{title}</h1>
          {subtitle && <p className="figure mt-2 text-sm text-ink-soft">{subtitle}</p>}
        </div>
        {actions}
      </div>
    </header>
  );
}
